// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingInfo_root__2JQWG","responsiveImage":"ListingInfo_responsiveImage__3breB","title":"ListingInfo_title__SKfFH"};